<template>
  <div class="box2">
    <div class="footer"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.box2 {
  position: relative;
  padding-bottom: 120px;
  width: 100%;
  background: linear-gradient(180deg, #feffff 0%, #e8f8ff 100%);

  .footer {
    position: absolute;
    // left: 50%;
    bottom: 0px;
    // transform: translate(-50%,0px);
    width: 736px;
    height: 196px;
    background: url("../../../assets/coursePage/cPuls/title.png") no-repeat;
    background-size: cover;
  }
}
</style>
